import m from "./_arrayAggregator.js";
import f from "./_baseAggregator.js";
import u from "./_baseIteratee.js";
import A from "./isArray.js";
var s = m, c = f, n = u, p = A;
function _(e, r) {
  return function(a, t) {
    var g = p(a) ? s : c, o = r ? r() : {};
    return g(a, e, n(t), o);
  };
}
var I = _;
export {
  I as default
};
//# sourceMappingURL=_createAggregator.js.map
